import './commonAssets';

import '../common/stylesheets/modules/details-uff.less';
import '../common/stylesheets/modules/widgets/full-width-background-widget.less';
import '../common/stylesheets/modules/widgets/stock-item-group-widget-card-design-v2.less';
import '../common/stylesheets/modules/widgets/stock-item-group-widget-card-design.less';
import '../common/stylesheets/modules/widgets/stock-item-group-widget.less';
import '../videoblocks/stylesheets/components/mixins.less';
import '../videoblocks/stylesheets/modules/details-uff.less';
import '../videoblocks/stylesheets/modules/search/tabbed-search.less';
import '../../assets/common/stylesheets/modules/signup/user-lead-form-innards.less';


import AppLoader from '../react/AppLoader/AppLoader';

import PopUpsContainer from '../react/PopUps/PopUpsContainer';
import ReactToastifyContainer from '../react/ReactToastify/containers/ReactToastifyContainer';
import VideoDetailsContainer from '../react/Details/containers/VideoDetailsContainer';
import NPSModalLoaderContainer from '../react/NPSModalLoader/NPSModalLoaderContainer';
import VideoSiteConstants from '../react/common/SiteConstants/VideoSiteConstants';
import EntTrialBanner from "../react/Trials/EntTrialBanner";
import AudioContainer from "../react/Audio/containers/AudioContainer";
import NavApps from "../react/app/NavApps";

// React entry point
AppLoader.load({
  routes: [
    {
      path: new VideoSiteConstants().getDetailsRoute(),
      component: VideoDetailsContainer,
    },
  ],
  auxApps: {
    ...NavApps,
    'audio-app': AudioContainer,
    'pop-up-container': PopUpsContainer, // FIXME: causes missing matching <div> in <section>
    'nps-modal': NPSModalLoaderContainer,
    'react-toastify-container': ReactToastifyContainer, // FIXME: causes missing matching <div> in <section>
  },
  propBasedApps: {
    'entTrialBanner': EntTrialBanner
  },
});
